import useEventDefinition from "hooks/useEventDefinition";
const useEventsAdditionalData = ({ eventData, definitionId = null }) => {
  var _a, _b;
  const eventDefinitionId = definitionId != null ? definitionId : eventData == null ? void 0 : eventData.event_definition_id;
  const { data, isLoading: isLoadingEventDefinition } = useEventDefinition(eventDefinitionId);
  const meta = !isLoadingEventDefinition ? {
    context: {
      event_definitions: {
        [eventDefinitionId]: data.eventDefinition
      }
    }
  } : null;
  const eventDefinitionEventProcedureId = (_b = (_a = data == null ? void 0 : data.eventDefinition) == null ? void 0 : _a.event_procedure) != null ? _b : "";
  return {
    meta,
    isLoadingEventDefinition,
    eventDefinitionEventProcedureId
  };
};
export default useEventsAdditionalData;
